import * as KatalMetrics from '@amzn/katal-metrics';
import { makeContextBuilder, makeDriverConfigBuilder } from './metrics-seller-central';
import { removeQueryString } from './utils';
const SERVICE_NAME = 'KatalMetrics';
export function createMetricsPublisher(sushiDriver) {
  const metricsErrorHandler = err => {
    console.warn(err);
  };
  let pageType = '';
  let subPageType = '';
  if (window.uept?.pageType) {
    pageType = window.uept.pageType;
    subPageType = window.uept.subPageType || '';
  }
  if (window.ue_pty) {
    pageType = window.ue_pty;
  }
  if (window.ue_spty) {
    subPageType = window.ue_spty;
  }
  const contextBuilder = makeContextBuilder(SERVICE_NAME);
  const url = removeQueryString(window.location.href);
  contextBuilder.addRelatedMetrics(...[new KatalMetrics.Metric.String('url', url), new KatalMetrics.Metric.String('pageType', pageType), new KatalMetrics.Metric.String('subPageType', subPageType), new KatalMetrics.Metric.String('katalPackageVersion', "1.3.77668.0")].map(s => {
    s.truncate = true;
    return s;
  }));
  if (!sushiDriver) {
    sushiDriver = makeDriverConfigBuilder(metricsErrorHandler).build();
  }
  const publisher = new KatalMetrics.Publisher(sushiDriver, metricsErrorHandler, contextBuilder.build());
  return {
    publisher: publisher.newChildActionPublisherForMethod('Load'),
    sushiDriver
  };
}
//# sourceMappingURL=metrics-publisher.js.map